import { requestBuilder } from '../../../http/RequestBuilder';
import type { CustomerExternalAccount } from '../types/ExternalAccount';

export const useGetSyncteraExternalAccountsForUser = requestBuilder.query<
    CustomerExternalAccount[],
    { userId: string }
>({
    endpoint: ({ userId }) =>
        `/api/admin/banking/external-account/user/${userId}`,
    queryKey: ({ userId }) => `getSyncteraExternalAccounts/${userId}`,
});
